import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { WireAssignedType, WireType } from '@/types/wireTypes';

export type CreateWirePayloadType = {
  type: WireAssignedType;
  name: string;
  amount?: string;
  currency: string;
  expected_payment_date?: string;
  notes?: string;
};

export const createWireApi = async (
  transactionId: string,
  data: CreateWirePayloadType,
  options: RequestOptions
): Promise<ApiResponseType<WireType>> => {
  const uri = `/organization/contracts/${transactionId}/wires/`;

  return authApiService.POST(uri, data, null, options);
};
